import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setCancelamentoAlteracaoDeFerias(params: Params): CustomFormQuestion[] {
  const { formMethods, questions } = params

  const { watch } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  //PERIODO 2
  const desejaSolicitarNovoPeriodo = watch(`form_answers.${titleForQuestion['Deseja solicitar novo período?']}`)

  const filteredQuestions = questions.filter((question) => {
    if (
      question.title == 'Data de Início' ||
      question.title == 'Quantidade de dias' ||
      question.title == 'Data de Fim' ||
      question.title == 'Deseja converter dias de férias em abono pecuniário?' ||
      question.title == 'Deseja receber adiantamento de 13º salário?' ||
      question.title == 'Anuência do Coordenador e do Gestor de alteração/cancelamento de férias'
    ) {
      if (desejaSolicitarNovoPeriodo != 'Sim') {
        return false
      }
    }

    //PERIODO 2
    if (question.title == 'Se sim, quantos dias') {
      if (desejaSolicitarNovoPeriodo != 'Sim') {
        return false
      } else {
        return true
      }
    }

    return true
  })

  return filteredQuestions
}
